import React from "react";
import { useFormContext } from "react-hook-form";
import { ContentSection, FormFields, FormNumberTextField, FormTextField } from "sprint-common-web";

import { validateDuration } from "../../../common/utils/validateDuration";
import { useCreateFileRecordState } from "../hooks/state/useCreateFileRecordState";

export const CreateAudioFileRecordTechInfoForm: React.FC = () => {
    const { control, errors } = useFormContext();
    const { isLoading } = useCreateFileRecordState();

    return (
        <ContentSection header="Technical" style={{ minHeight: "80vh" }} isLoading={isLoading}>
            <FormFields>
                <FormTextField label="Audio format" name={"audioFormat"} control={control} errors={errors} />
                <FormTextField
                    rules={{ validate: validateDuration }}
                    label="Duration"
                    name={"audioDuration"}
                    control={control}
                    errors={errors}
                    mask="99:99:99"
                />
                <FormNumberTextField label="Sample rate" name={"audioSampleRate"} control={control} errors={errors} />
                <FormNumberTextField label="Bitrate" name={"audioBitrate"} control={control} errors={errors} />
                <FormNumberTextField label="Channels" name={"audioChannels"} control={control} errors={errors} />
            </FormFields>
        </ContentSection>
    );
};
